<template>
  <div class="ticket-period">
    <!-- 利用開始日-->
    <div class="item">
      <div class="label">
        <div>{{ $t("common.startDateLabel") }}</div>
        <div>Start date of use</div>
      </div>
      <div class="date">
        <span>
          {{ displayDate(start) }}
        </span>
        <span class="dash">〜</span>
      </div>
    </div>

    <!-- 利用終了日-->
    <div class="item">
      <div class="label">
        <div>{{ $t("common.endDateLabel") }}</div>
        <div>End date of use</div>
      </div>

      <div class="date">
        {{ displayDate(limit).split(".")[0] }}.
        <span class="due"
          >{{ displayDate(limit).split(".")[1] }}.{{
            displayDate(limit).split(".")[2]
          }}</span
        >
        <span class="text">まで</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BFaceAvailablePeriodDisp",
  props: {
    start: {
      type: String,
      required: true,
    },
    limit: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.ticket-period {
  display: flex;
  margin-top: 6px;
  @media screen and (min-height: 760px) {
    margin-top: 20px;
  }
}

.label {
  font-size: 11px;
  line-height: 21px;

  @media screen and (min-height: 760px) {
    font-size: 14px;
    line-height: 24px;
  }
}

.date {
  display: flex;
  height: 35px;
  margin-top: 3px;
  align-items: flex-end;
  font-size: 3.5vw;
  font-weight: bold;

  @media screen and (min-height: 760px) {
    height: 45px;
    font-size: 4.2vw;
  }
}

.dash {
  margin: 0 6vw;
  font-weight: normal;
}

.due {
  margin-bottom: -5px;
  font-size: 10vw;
}

.text {
  font-weight: normal;
  font-size: 11px;
}
</style>
